module.exports = "<img draggable=\"false\"\n  [src]=\"imageSrcBase + '/' + image\"\n  [srcset]=\"imageSrcBase + '/' + imageRetina + ' 2x'\"\n  [sizes]=\"width\"\n  [alt]=\"title\" \n  [width]=\"width\" [height]=\"height\">"


//////////////////
// WEBPACK FOOTER
// ./src/app/poster-image/poster-image.component.html
// module id = ./src/app/poster-image/poster-image.component.html
// module chunks = main